import { LOCAL_STORAGE_KEYS } from "../../constants";
import { getLocalStorageItem } from "../../utils/storageHelper";
export var MenuHeirarchy = {
    'Features': 'Routes',
    // {'/menuRoute': {features}}
    'FeatureAccesses': 'Name',
    //{'FeatureName': {feature accesses} }
    'Attribute': 'Name' // {'FeatureAccessName': Attribute value}
};
export var HeirarchyKeys = Object.keys(MenuHeirarchy);
export var Attributes = ['true', 'false'];
export var getAttributeValue = function (attribute) {
    switch (attribute) {
        case 'true':
        case 'false':
            return attribute === 'true';
        default:
            return attribute;
    }
};
export function nestedArrayMapping(items) {
    var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var heirarchy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : MenuHeirarchy;
    var keys = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : HeirarchyKeys;
    var acc = {};
    var childKey = keys[index];
    var key = heirarchy[childKey];
    items === null || items === void 0 || items.forEach(function (it) {
        var childName = it[key];
        var children = it[childKey];
        if (index === keys.length - 1) {
            var attribute = children;
            acc[childName] = getAttributeValue(attribute);
            return;
        }
        if (Array.isArray(children)) {
            acc[childName] = nestedArrayMapping(children, index + 1, heirarchy, keys);
        }
    });
    return acc;
}
export var getMenusFromMenuGroups = function (menuGroups) {
    var _menuGroups$flatMap;
    var menu = (_menuGroups$flatMap = menuGroups === null || menuGroups === void 0 ? void 0 : menuGroups.flatMap(function (group) { return group.Menus; })) !== null && _menuGroups$flatMap !== void 0 ? _menuGroups$flatMap : [];
    return menu;
};
export var setRbacStorage = function (menuGroups) {
    if (!menuGroups)
        return;
    var menus = getMenusFromMenuGroups(menuGroups);
    var menuFeatureMap = nestedArrayMapping(menus);
    localStorage.setItem(LOCAL_STORAGE_KEYS.RBAC, JSON.stringify(menuFeatureMap));
};
export var getRbacByPath = function (path) {
    var _rbac$path;
    var rbac = getLocalStorageItem(LOCAL_STORAGE_KEYS.RBAC);
    return (_rbac$path = rbac === null || rbac === void 0 ? void 0 : rbac[path]) !== null && _rbac$path !== void 0 ? _rbac$path : {};
};
